const InitialData = {
    loading: { loading: true, error: false, errorCode: "", errorMessage: "", data: [] },
    error: { loading: false, error: true, errorCode: "", errorMessage: "", data: [] },
    completed: { loading: false, error: false, errorCode: "", errorMessage: "", data: [] },
}

export default InitialData;